import { isCypress, isDevelopment } from './isProduction';

let injectionPromise;

/**
 * An injection singleton for loading the Google Maps API. Add additional libraries to the query string
 * as needed; we do not want to load more than one copy of the API on the page at once.
 *
 * @return {Promise<null>} resolves when the API has been loaded
 */
export const gmapsPatientCiKey = 'AIzaSyA6j-WbY0ZD_L1V7Ehbkg_WI9RzVgi9oTY';
export const gmapsPatientProdKey = 'AIzaSyDxnx63Rf_Xluu5sHoGGsx7VITvge5yRLc';
const gmapsUnsecuredKey = 'AIzaSyD1cGNhJz2BiG4oODjDAkfOH__dxXC_N10';

export default (key = gmapsUnsecuredKey) =>
    new Promise(resolve => {
        if (window.google && window.google.maps) {
            return resolve();
        } else if (injectionPromise) {
            return injectionPromise.then(resolve);
        }

        let gmKey = isCypress() || isDevelopment() ? gmapsPatientCiKey : key;

        injectionPromise = new Promise(innerResolve => {
            const initGmApi = () => {
                const gmAPI = document.createElement('script');
                gmAPI.defer = true;
                gmAPI.src = `https://maps.googleapis.com/maps/api/js?key=${gmKey}&libraries=places`;
                gmAPI.onload = innerResolve;

                document.body.appendChild(gmAPI);
            };

            if (document.readyState === 'complete') {
                setTimeout(initGmApi, 0);
            } else {
                window.addEventListener('load', initGmApi);
            }
        }).then(resolve);

        return injectionPromise;
    });
